export default {"src":"/_next/static/media/cave.e0003317.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};